/**
 * 全局状态(Zustand)
 * 当前只有:登录态(token + user)
 * 后续可加:模块 4 enabled flag、用户偏好等
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: number
  phone: string
  nickname: string | null
  isAdmin: boolean
}

interface AuthState {
  token: string | null
  user: User | null
  setAuth: (token: string, user: User) => void
  logout: () => void
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setAuth: (token, user) => {
        localStorage.setItem('gaokao_token', token)
        set({ token, user })
      },
      logout: () => {
        localStorage.removeItem('gaokao_token')
        set({ token: null, user: null })
      },
    }),
    { name: 'gaokao-auth' },
  ),
)
